import * as angular from "angular";
import * as _ from "lodash";
import { BuildingService } from "../services/building.service";
import { House } from "./house.model";

export class Building {
    private $q: any;
    private resource: BuildingService;

    public id?: string;
    public timestamp?: Date | string;
    public creationdatetime?: Date | string;
    public lastmodifieddatetime?: Date | string;
    public name?: string;
    public type?: string;
    public accessibility?: string;
    public hname?: string;
    public hnumber?: string;
    public haddress?: string;
    public hcity?: string;
    public hstate?: string;
    public hprecinct?: string;
    public hzipcode?: string;
    public notes: any;
    public hlatitude?: any;
    public hlongitude?: any;
    public hlocationtype?: any;
    public houses?: [House];

    constructor($q: any, BuildingService: BuildingService, data?: object) {
        this.$q = $q;
        this.resource = BuildingService;

        if (data) {
            this.setData(data);
        }
    }

    clean(building: Building): void {
        for (let key in building) {
            if (building.hasOwnProperty(key)) {
                if (building[key] && typeof building[key] === "string") {
                    building[key] = building[key].trim();
                    if (building[key] === "") building[key] = null;
                }
            }
        }
    }

    getID(): string {
        return this.id;
    }

    setData(data: object): void {
        _.merge(this, data);
        this.clean(this);
    }

    update(): Promise<any> {
        const deferred = this.$q.defer();
        this.lastmodifieddatetime = null;
        this.resource.update(this).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    angular.extend(this, json.data);
                    deferred.resolve(this);
                } else {
                    deferred.reject(json);
                }
            },
            (response: object) => {
                deferred.reject(response);
            }
        );
        return deferred.promise;
    }

    formatAddressLine1(): string {
        let line = "";
        if (this.hname) line += this.hname + ", ";
        if (this.hnumber) line += this.hnumber + ", ";
        if (this.haddress) line += this.haddress;
        return line;
    }

    formatAddressLine2(): string {
        let line = "";
        if (this.hcity) line += this.hcity + ", ";
        if (this.hstate) line += this.hstate + ", ";
        if (this.hprecinct) line += this.hprecinct + ", ";
        if (this.hzipcode) line += this.hzipcode;
        return line;
    }

    getAccessType(): string {
        return this.accessibility ? this.accessibility : "unspecified";
    }
}
